/* eslint-disable */
import {
  ORDER_STATUS_CANCELLED,
  ORDER_STATUS_COMPLETED,
  ORDER_STATUS_CONFIRMED,
  ORDER_STATUS_DELIVERING,
  ORDER_STATUS_NEW,
  ORDER_STATUS_NONE,
  ORDER_STATUS_ON_HOLD,
  ORDER_STATUS_TO_BE_CONFIRMED,
} from '../../Constants/Order/Order.constants';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the given `status` is invalid
 * @export
 * @class OrderInvalidStatusError
 * @extends {Error}
 */
export class OrderInvalidStatusError extends Error {
  /**
   * Creates an instance of OrderInvalidStatusError
   * @param {string} message The Error `message`
   * @memberof OrderInvalidStatusError
   */
  constructor(message) {
    super(message);
    this.name = `OrderInvalidStatusError`;
  }
}

/**
 * Called when the given `status` is invalid
 * @param {any} status The invalid `status`
 * @returns {never} never
 */
const throwOrderInvalidStatusError = (status) => {
  throw new OrderInvalidStatusError(
    stripIndent(`
    Expected "status" to be one of
      "${ORDER_STATUS_CANCELLED}"
      "${ORDER_STATUS_COMPLETED}"
      "${ORDER_STATUS_CONFIRMED}"
      "${ORDER_STATUS_DELIVERING}"
      "${ORDER_STATUS_ON_HOLD}"
      "${ORDER_STATUS_TO_BE_CONFIRMED}"
      "${ORDER_STATUS_NONE}"
      "${ORDER_STATUS_NEW}"
    Got: "${status}".
    `),
  );
};

export default throwOrderInvalidStatusError;
